import { palettes } from '@backstage/theme';

/** Matches built-in light palette shape from `@backstage/theme`. */
type LightPalette = typeof palettes.light;
/** Matches built-in dark palette shape (e.g. `primary.dark` is defined). */
type DarkPalette = typeof palettes.dark;

const navLight = {
  ...palettes.light.navigation,
  background: '#ffffff',
  indicator: '#0891b2',
  color: '#64748b',
  selectedColor: '#0f172a',
  navItem: {
    ...palettes.light.navigation.navItem,
    hoverBackground: '#f1f5f9',
  },
  submenu: {
    ...palettes.light.navigation.submenu,
    background: '#f1f5f9',
  },
};

const navDark = {
  ...palettes.dark.navigation,
  background: '#080c14',
  indicator: '#38bdf8',
  color: '#64748b',
  selectedColor: '#e2e8f0',
  navItem: {
    ...palettes.dark.navigation.navItem,
    hoverBackground: '#111827',
  },
  submenu: {
    ...palettes.dark.navigation.submenu,
    background: '#111827',
  },
};

/** Dark-first "mission control" navy / cyan palette. */
export const lightPalette: LightPalette = {
  ...palettes.light,
  background: {
    ...palettes.light.background,
    default: '#f8fafc',
    paper: '#ffffff',
  },
  primary: { main: '#0891b2' },
  border: '#e2e8f0',
  textContrast: '#0f172a',
  textSubtle: '#64748b',
  textVerySubtle: '#94a3b8',
  link: '#0891b2',
  linkHover: '#06b6d4',
  highlight: '#e0f2fe',
  infoBackground: '#e0f2fe',
  infoText: '#0c4a6e',
  navigation: navLight,
  pinSidebarButton: {
    ...palettes.light.pinSidebarButton,
    icon: '#f8fafc',
    background: '#64748b',
  },
};

export const darkPalette: DarkPalette = {
  ...palettes.dark,
  background: {
    ...palettes.dark.background,
    default: '#0a0e17',
    paper: '#111827',
  },
  primary: { main: '#38bdf8', dark: '#0891b2' },
  secondary: { main: '#64748b' },
  border: '#1b2735',
  textContrast: '#e2e8f0',
  textSubtle: '#64748b',
  textVerySubtle: '#475569',
  link: '#38bdf8',
  linkHover: '#7dd3fc',
  highlight: '#0c4a6e',
  infoBackground: '#0c4a6e',
  infoText: '#e0f2fe',
  navigation: navDark,
  pinSidebarButton: {
    ...palettes.dark.pinSidebarButton,
    icon: '#0a0e17',
    background: '#64748b',
  },
};

export const pageGradients = {
  default: {
    home: ['#0a0e17', '#38bdf8'] as [string, string],
    documentation: ['#0891b2', '#0a0e17'] as [string, string],
    apis: ['#111827', '#38bdf8'] as [string, string],
  },
} as const;
